import all from '@mailobj-browser/front/js/selectors/all.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import * as utilities from '#utilities/js/styles.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import { elements } from '../../styles.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'

const onClick = object(listener, {
  type: click,
  passive,
  task: (
    { ownerDocument }
  ) => {
    const unavailableList = all(`.${elements.registrar_unavailable}`, ownerDocument)

    if (unavailableList.length > 0) {
      for (const unavailable of unavailableList) {
        unavailable.classList.toggle(utilities.modifiers.display.none)
      }
    }
  }
})

export default element => {
  onClick.listen(element)
}